// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1_container__3ox5G","icon":"Section1_icon__9keUK","text1":"Section1_text1__2Et-D","text2":"Section1_text2__3JW9a"};